import ErrorModel from '../models/ErrorModel.js'
import BaseObjectStore from './base/base-object-store.js'
import { captureError } from '../utilities/use-sentry.js'

class ErrorStore extends BaseObjectStore {
    constructor () {
        super({
            errors: [],
        })
    }

    getErrors () {
        return this.get('errors')
    }

    addError (error, stack) {
        // Extract the error message from the error object
        const message = error instanceof Error ? error.message : String(error)

        const newError = new ErrorModel({
            error,
            message,
            stack,
        })

        captureError(error) // Captures error and sends to Sentry

        this.setState('errors', [...this.getErrors(), newError])
    }

    removeError (error) {
        this.setState('errors', this.getErrors().filter(e => e !== error))
    }

    clearErrors () {
        this.setState('errors', [])
    }
}

export default new ErrorStore()
